module.exports = __webpack_public_path__ + "img/1970East-048_WEB-min.5c46c4c7.jpg";